import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  premiumUpsellTitleForTrack: {
    id: 't.premiumUpsellTitleForTrack',
    defaultMessage: 'Upgrade to Pandora Premium to listen to this song',
  },
  premiumUpsellTitleForAlbum: {
    id: 't.premiumUpsellTitleForAlbum',
    defaultMessage: 'Upgrade to Pandora Premium to listen to this album',
  },
  premiumUpsellTitleForPlaylist: {
    id: 't.premiumUpsellTitleForPlaylist',
    defaultMessage: 'Upgrade to Pandora Premium to listen to this playlist',
  },
  premiumUpsellBodyForTrack: {
    id: 't.premiumUpsellBodyForTrack',
    defaultMessage: 'Listen to this song or any song you want with Pandora Premium.',
  },
  premiumUpsellBodyForAlbum: {
    id: 't.premiumUpsellBodyForAlbum',
    defaultMessage: 'Listen to this album or any song you want with Pandora Premium.',
  },
  premiumLinkedPlaylistTitle: {
    id: 't.premiumLinkedPlaylistTitle',
    defaultMessage: 'Playlist Created!',
  },
  premiumUpsellBodyForPlaylist: {
    id: 't.premiumUpsellBodyForPlaylist',
    defaultMessage: 'Listen to this playlist or any song you want with Pandora Premium.',
  },
  startFreeTrial: {
    id: 't.startFreeTrial',
    defaultMessage: 'Start Free Trial',
  },
  upgrade: {
    id: 't.upgrade',
    defaultMessage: 'Upgrade',
  },
  notNow: {
    id: 't.notNow',
    defaultMessage: 'Not Now',
  },
  okay: {
    id: 't.okay',
    defaultMessage: 'OK',
  },
  viewPlaylist: {
    id: 't.viewPlaylist',
    defaultMessage: 'View Playlist',
  },
  close: {
    id: 't.close',
    defaultMessage: 'Close',
  },
  dismiss: {
    id: 't.dismiss',
    defaultMessage: 'Dismiss',
  },
  welcomeToPandoraPremiumFamilyTitle: {
    id: 't.welcomeToPandoraPremiumFamily',
    defaultMessage: 'Welcome to Pandora Premium Family',
  },
  welcomeToPandoraPremiumFamilyBody: {
    id: 't.welcomeToPandoraPremiumFamilyBody',
    defaultMessage:
      'Start by adding people to your family plan or skip ahead and go straight to the music.',
  },
  welcomeToPandoraPremiumFamilyInviteButton: {
    id: 't.welcomeToPandoraPremiumFamilyInviteButton',
    defaultMessage: 'Invite People',
  },
  welcomeToPandoraPremiumFamilySkipButton: {
    id: 't.welcomeToPandoraPremiumFamilySkipButton',
    defaultMessage: 'Skip For Now',
  },
  confirmUserPartnerUpgradeHeader: {
    id: 'p.confirmUserPartnerUpgradeHeader',
    defaultMessage: 'Upgrade to {planName} through {partner}.',
  },
  loggedInAsUser: {
    id: 'p.loggedInAsUser',
    defaultMessage: 'You are logged in as\n{listenerEmail}',
  },
  continue: {
    id: 'p.continue',
    defaultMessage: 'Continue',
  },
  logInWithDifferentAccount: {
    id: 'p.logInWithDifferentAccount',
    defaultMessage: 'Log in with a different account',
  },
  welcomeToPandoraTitle: {
    id: 't.welcomeToPandoraTitle',
    defaultMessage: 'Welcome to {planName}',
  },
  welcomeToPandoraPartnerUpgradeBody: {
    id: 't.welcomeToPandoraPartnerUpgradeBody',
    defaultMessage: 'Enjoy your {planName} account through {partner}.',
  },
  welcomeToPandoraPremiumFamilyPartnerUpgradeBody: {
    id: 't.welcomeToPandoraPremiumFamilyPartnerUpgradeBody',
    defaultMessage: '{welcomeToPandoraPartnerUpgradeBody} {welcomeToPandoraPremiumFamilyBody}',
  },
  startListening: {
    id: 't.startListening',
    defaultMessage: 'Start Listening',
  },
  legalese: {
    id: 't.legalese',
    defaultMessage: '{privacyAndTerms} {termsAndConditions}',
  },
  termsAndConditions: {
    id: 't.termsAndConditions',
    defaultMessage:
      'By continuing, you acknowledge and accept the { subscriptionTerms }. To cancel your subscription, visit { partner }.',
  },
  subscriptionTerms: {
    id: 't.subscriptionTerms',
    defaultMessage: 'Pandora Subscription Terms',
  },
  terms: {
    id: 't.terms',
    defaultMessage: 'Terms of Service',
  },
  privacy: {
    id: 't.privacy',
    defaultMessage: 'Privacy Policy',
  },
  somethingGoneWrongPartnerUpgrade: {
    id: 't.somethingGoneWrongPartnerUpgrade',
    defaultMessage: "We're sorry, something has gone wrong.",
  },
  returnToPartnerSite: {
    id: 't.returnToPartnerSite',
    defaultMessage: 'Please return to the {partner} site to try again.',
  },
  premiumAccessEndTrialEligibleHeader: {
    id: 't.premiumAccessEndTrialEligibleHeader',
    defaultMessage: 'Your Pandora Premium session has ended. Want more?',
  },
  premiumAccessEndTrialEligibleButton: {
    id: 't.premiumAccessEndTrialEligibleButton',
    defaultMessage: 'Start Free Trial',
  },
  premiumAccessEndTrialIneligibleHeader: {
    id: 't.premiumAccessEndTrialIneligibleHeader',
    defaultMessage: 'Your Pandora Premium session has ended. Want more?',
  },
  premiumAccessEndTrialIneligibleButton: {
    id: 't.premiumAccessEndTrialIneligibleButton',
    defaultMessage: 'Upgrade',
  },
  adBlockerCTA: {
    id: 't.adBlockerCTA',
    defaultMessage: 'Show Me How',
  },
  browserAutoplayBlockCTA: {
    id: 't.browserAutoplayBlockCTA',
    defaultMessage: 'Show Me How',
  },
  adBlockerHeadline: {
    id: 't.adBlockerHeadline',
    defaultMessage: 'Ad Blocker is on...',
  },
  browserAutoplayBlockHeadline: {
    id: 't.browserAutoplayBlockHeadline',
    defaultMessage: 'Automatic Playback is Disabled',
  },
  unableToJoinFamily: {
    id: 't.unableToJoinFamily',
    defaultMessage: 'Unable to Join Pandora Premium Family.',
  },
  adBlockerBody: {
    id: 't.adBlockerBody',
    defaultMessage:
      'Unlock your reward and help us continue to support the artist you love (and keep Pandora free) by allowlisting our site or upgrading your account.',
  },
  adBlockerBodyForAntiAdBlockerExperiment: {
    id: 't.adBlockerBodySlowRamp',
    defaultMessage:
      'To prevent playback issues you’ll need to allowlist Pandora. Ads on Pandora support the artists you love and keep Pandora free.',
  },
  browserAutoplayBlockBody: {
    id: 't.browserAutoplayBlockBody',
    defaultMessage:
      "If you want Pandora to automatically start playing at launch, you'll need to enable this in your browser settings.",
  },
} as const);

export const ErrorMessages = defineMessages({
  somethingGoneWrong: {
    id: 'somethingGoneWrong',
    defaultMessage: 'Something has gone wrong. Please try again later.',
  },
  oops: {
    id: 'oops',
    defaultMessage: 'Oops!',
  },
} as const);
export const ModalStyles = Object.freeze({
  WIDE: 'wide',
  PANDORA_PREMIUM: 'pandoraPremium',
  PANDORA_PREMIUM_FAMILY: 'pandoraPremiumFamily',
  PANDORA_PARTNER_UPGRADE: 'partnerUpgrade',
  PANDORA_PARTNER_UPGRADE_WELCOME: 'pandoraPartnerUpgradeWelcome',
} as const);

export const ModalTypes = Object.freeze({
  STANDARD: 'ModalStandard',
} as const);
